import React from "react";
import PropTypes from "prop-types";
import { Schema } from "@sparefoot/react-commons";
import { useSelector } from "react-redux";

export const createBreadcrumbSchema = (breadcrumbs) => ({
	"@context": "http://schema.org",
	"@type": "BreadcrumbList",
	itemListElement: breadcrumbs
		.filter((crumb) => crumb.label)
		.map((crumb, index) => ({
			"@type": "ListItem",
			position: index + 1,
			item: {
				"@type": "Website",
				"@id": `storage.com${crumb.href}`,
				name: crumb.name || crumb.label
			}
		}))
});


const createCLPBreadcrumbSchema = (breadcrumbs, baseUrl, canonicalUrl) => ({
	"@context": "https://schema.org",
	"@type": "BreadcrumbList",
	"@id": `${canonicalUrl}#breadcrumb`,
	itemListElement: breadcrumbs
		.filter((crumb) => crumb.label)
		.map((crumb, index) => ({
			"@type": "ListItem",
			position: index + 1,
			item: {
				"@id": `${baseUrl}${crumb.href}`,
				name: crumb.name || crumb.label,
				url: `${baseUrl}${crumb.href}`
			}
		}))
});

const BreadcrumbSchema = ({ breadcrumbs, isCLP = false, canonicalUrl }) => {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	const breadcrumbJSON = isCLP
		? createCLPBreadcrumbSchema(breadcrumbs, baseUrl, canonicalUrl)
		: createBreadcrumbSchema(breadcrumbs);
	return <Schema schema={breadcrumbJSON} />;
};

BreadcrumbSchema.propTypes = {
	breadcrumbs: PropTypes.instanceOf(Array),
	isCLP: PropTypes.bool,
	canonicalUrl: PropTypes.string
};

export default BreadcrumbSchema;
